var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListViewIcon = function SvgListViewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 1.139C0 .509.51 0 1.143 0h13.714a1.14 1.14 0 1 1 0 2.278H1.143A1.14 1.14 0 0 1 0 1.138m0 5.694c0-.63.51-1.139 1.143-1.139h13.714a1.14 1.14 0 1 1 0 2.278H1.143A1.14 1.14 0 0 1 0 6.833m16 5.695c0 .63-.51 1.139-1.143 1.139H1.143a1.14 1.14 0 1 1 0-2.278h13.714A1.14 1.14 0 0 1 16 12.528"
  })));
};
export default SvgListViewIcon;